<template>
  <div class="container">
    <el-row class="title">
      <h2 class="main-title">数据来源: {{canteen.canteen_name}} {{tsToDate}}</h2>

      <!--<h3 class="sub-title">当前餐厅审核完毕? <el-button type="primary" size="mini" @click="back"> 返回待审核列表</el-button></h3>-->
    </el-row>
    <el-row :gutter="10" v-if="currentDishModel">
      <el-row :gutter="5" class="class-dish">
        <el-col :span="18">
          <el-card v-if="currentDishModel" class="box-card">
            <div slot="header" class="clearfix">
              <h3 class="header-title">
                第<span class="danger-text">{{currentIndex + 1}}</span><span>/{{`${dishModelCount}`}}个碗</span>
                {{currentDishModel && currentDishModel.dish_name ?
                currentDishModel.dish_name : '暂无名称' }}</h3>
              <div class="btn-wrapper-1">
                <el-button type="primary" :disabled="currentIndex < 1"  @click="preDishModel">上一个例图</el-button>
                <el-button type="primary" :disabled="currentIndex === dishModelCount - 1"  @click="nextDishModel">下一个例图
                </el-button>
                <el-button type="success" @click="checkPass">当前例图审核通过</el-button>
                <el-button type="danger"  @click="checkFail">当前例图审核不通过</el-button>
              </div>
            </div>
            <!--<div class="image-wrapper">-->
                <!--<img :src="currentDishModel.dish_image_url" class="image-item" alt="">-->
            <!--</div>-->
            <classDishWrapper :image="currentDishModel" class="current-dish-model"></classDishWrapper>
          </el-card>
          <span v-else>暂无例图!</span>
        </el-col>
        <el-col :span="6">
          <el-card class="delete-card" body-style='{height: 100%}'>
            <div slot="header" class="clearfix">
              <h3 class="header-title danger-text">纠错状态图片</h3>
              <!--<el-button type="primary" @click="goToMark">去重新标注</el-button>-->
            </div>
            <div class="image-wrapper-1">
              <div class="image-item-wrapper" v-for="dish in deletedImages" :key="dish.dish_img_uuid">
                <el-popover
                  popper-class="big-img"
                  ref="popover2"
                  placement="top-start"
                  trigger="hover">
                  <img :src="dish.dish_img_url" class="image-item" slot="reference" alt="" width="25px" height="25px" >
                  <div class="big-img-wrapper">
                    <el-button  type="primary" class="btn" style="position: absolute"
                                @click="unDelete(dish)">撤回
                    </el-button>
                    <img :src="dish.dish_img_url" alt="" width="150">
                  </div>
                </el-popover>
              </div>
            </div>
          </el-card>
        </el-col>
      </el-row>
      <h2 class="process-title">
        <!--// 自查-->
        <span>检查下列图片,如果和上面的例图<span class="strong-text">不相符</span>,请点击 图片上的<i
          class="el-icon-delete danger-text"></i>将图片置为纠错状态</span>
        <el-badge class="mark" :value="currentClassImagesLeft.length">
          <el-tag type="success">总计</el-tag>
        </el-badge>
        <!--审查-->
      </h2>
      <imageMarkWrapperforDeceted
        v-if="currentClassImages.length > 0"
        :images="currentClassImagesLeft"
        :current_class_id="currentDishModel.class_id"
        :selfCheck="selfCheck"
        @pageChange="pageChange"
        @delete="handleDelete"
      >
      </imageMarkWrapperforDeceted>
      <h3 class="tip-wrapper" v-else>
        当前例图暂暂无图片
        <el-button type="primary" :disabled="currentIndex < 1"  @click="preDishModel">上一个例图</el-button>
        <el-button type="primary" :disabled="currentIndex === dishModelCount - 1"  @click="nextDishModel">下一个例图
        </el-button>
      </h3>
    </el-row>
    <el-row :gutter="10" v-else>
      <span>暂无标准例图</span>
    </el-row>
  </div>
</template>
<script>
import {mapGetters, mapMutations} from 'vuex';
import {
  apiCheckDetectedImage,
  apiGetBatchImageList,
  apiGetClassDishByClassId,
  apiGetDetectedImage,
  apiQueryCanteenClassList
} from '@/api';
import imageMarkWrapperforDeceted from '_c/imageMarkWrapperforDeceted';

import classDishWrapper from '_c/classDishWrapper';
import moment from 'moment';

export default {
  name: 'detectedImageCheck',
  components: {
    imageMarkWrapperforDeceted,
    classDishWrapper
  },
  data () {
    const validatePass = (rule, value, callback) => {
      console.log(`ssssssssssssssss`, value);
      if (value === '') {
        callback(new Error('请输出审查意见'));
      } else {
        callback();
      }
    };
    return {
      modelList: [],
      currentIndex: 0,
      checkFailReasonShow: false,
      checkFailReason: '',
      detectedData: {},
      deletedImages: [],
      modelList2: []
    };
  },
  mounted () {
    this.setSubTitle('采集图片纠错');
    this.getModelList();
    this.getDetectedImages();
  },
  methods: {
    ...mapMutations([
      'setMarkedImageList',
      'changeCurrentDishModelIndex',
      'setBatchTag',
      'emitLoading',
      'removeLoading',
      'setBatchList',
      'setBatchImageList',
      'setSubTitle',
      'unMark',
      'clearCheckTextObj',
      'setSubTitle',
      'emitLoading1'
    ]),
    // 保存标记状态到本地
    saveLocal () {

    },
    goToMark () {
      // if (this.currentIndex === this.dishModelCount && (!this.currentClassImages || this.currentClassImages.length ===
      //   0)) {
      //
      // }
    },
    back () {
      this.$router.push({
        name: 'taskAdmin'
      });
    },
    handleDelete (dish_img_uuid) {
      let dish = this.$_.find(this.currentClassImages, function (a) {
        return a.dish_img_uuid === dish_img_uuid;
      });
      this.deletedImages.push(dish);
    },
    pageChange (page, isLastPage) {
      console.log(page, isLastPage);
      // this.isLastPage = isLastPage;
    },
    async getDetectedImages () {
      this.emitLoading();
      try {
        let res = await apiGetDetectedImage({
          canteenId: this.canteen.canteen_id,
          dateRange: this.dateRange,
          username: this.username,
          label_task_uuid: this.taskUuid
        });
        let res1 = await apiGetClassDishByClassId(Object.keys(res));
        this.modelList = res1.class_admin_list;
        this.detectedData = res;
        this.removeLoading();
      } catch (e) {
        this.removeLoading();
      };
    },
    unDelete (dish) {
      this.unMark({dish_img_uuid: dish.dish_img_uuid});
    },
    showCheckFailReasonDialog () {
      this.checkFailReasonShow = true;
    },
    cancelDialog () {
      this.checkFailReason = '';
      this.checkFailReasonShow = false;
    },
    async getModelList () {
      try {
        let res = await apiQueryCanteenClassList({ canteenId: this.canteen.canteen_id, apiKey: this.apiKey });
        console.log(res.dish_info_list);
        this.modelList2 = res.dish_info_list;
      } catch (e) {
        console.log(e);
      };
    },
    checkFail () {
      this.$confirm('是否不通过', '提示', {
        type: 'warning',
        confirmButtonText: '确定',
        cancelButtonText: '取消'
      }).then(async () => {
        try {
          this.emitLoading();
          await apiCheckDetectedImage({
            // 1 审查通过
            // -1 审查不通过
            checked: -1,
            class_id: this.currentDishModel.class_id,
            discard_img_uuid_list: [],
            dish_image_uuid_list: this.dish_img_uuid_list,
            label_task_uuid: this.taskUuid,
            is_finish: this.isLastPage
          });
          this.$message.warning('当前例图审核完成, 正在跳转下一例图');
          this.currentIndex++;
          this.removeLoading(500);
        } catch (e) {
          this.removeLoading(500);
          this.$message.error('当前例图审核完成, 正在跳转下一例图');
          console.log(e);
        }
      }).catch(e => {
        this.$message.error('已取消');
      });
    },
    async checkPass () {
      try {
        this.emitLoading();
        await apiCheckDetectedImage({
          checked: 1,
          class_id: this.currentDishModel.class_id,
          discard_img_uuid_list: this.discard_img_uuid_list,
          dish_img_uuid_list: this.dish_img_uuid_list,
          label_task_uuid: this.taskUuid,
          is_finish: this.isLastPage
        });
        this.$message.warning('当前例图审核完成, 正在跳转下一例图');
        this.currentIndex++;
        this.removeLoading(500);
      } catch (e) {
        this.$message.error('当前例图审核完成, 正在跳转下一例图');
        console.log(e);
      }
    },
    // 查询批次图片
    async getImagesByBatchTag () {
      if (this.$route.params.selfCheck && this.$route.params.selfCheck === true) {
        // 从vuex中获取
      } else {
        // 请求服务器中相应的
        let res = await apiGetBatchImageList({
          canteen_id: this.canteen.canteen_id,
          batch: this.batch_tag,
          apiKey: this.apiKey
        });
        // let keys = ;
        console.log(Object.keys(res));
        // this.modelList = await apiGetClassDishByClassId(Object.keys(res));
        this.setMarkedImageList(res);
      }
    },
    // 下一个例图
    nextDishModel () {
      if (this.currentIndex < this.modelList.length) {
        this.currentIndex++;
      }
    },
    // 上一个例图
    preDishModel () {
      if (this.currentIndex > 0) {
        this.currentIndex--;
      }
    },
    submitMarkedData () {
      this.$alert('标注还未完成, 请继续标注', '', {
        confirmButtonText: '确定'
      });
    },
    checkComplete () {
      this.$alert('即将跳转到标注页面', '提示', {
        confirmButtonText: '确定',
        callback: () => {
          this.$router.push({
            name: 'markProcess1',
            params: {
              selfCheck: true
            }
          });
        }
      });
    }
  },
  computed: {
    ...mapGetters([
      'markedImageList',
      'listQuery',
      'userinfo',
      'checkTextObjList'
    ]),
    dish_img_uuid_list () {
      return this.currentClassImages.map(a => a.dish_img_uuid);
    },
    tsToDate () {
      return moment(this.dateRange.start_ts * 1000).format('YYYY年MM月DD日');
    },
    isLastPage () {
      return this.currentIndex + 1 === this.dishModelCount;
    },
    taskUuid () {
      return this.$route.params.checkInfo.label_task_uuid;
    },
    username () {
      return this.userinfo().username;
    },
    modelist1 () {
      return this.$store.getters.modelList || [];
    },
    canteen () {
      let {canteen_name, canteen_id} = this.$route.params.checkInfo;
      return {canteen_id, canteen_name};
    },
    dateRange () {
      let ts = this.$route.params.checkInfo.day_ts;
      return {
        start_ts: ts,
        end_ts: ts + 24 * 3600
      };
    },
    discard_img_uuid_list () {
      return this.deletedImages.map((a) => a.dish_img_uuid);
    },
    selfCheck () {
      if (this.$route.params.selfCheck) {
        return this.$route.params.selfCheck;
      } else {
        return false;
      }
    },
    currentClassImages () {
      if (this.currentDishModel) {
        return this.detectedData[this.currentDishModel.class_id] &&
        this.detectedData[this.currentDishModel.class_id].marked_img_info
          ? this.detectedData[this.currentDishModel.class_id].marked_img_info : [];
      } else {
        return [];
      }
    },
    currentClassImagesLeft () {
      return this.$_.differenceBy(this.currentClassImages, this.deletedImages);
    },

    apiKey () {
      return this.userinfo().api_key;
    },
    userGroup () {
      return this.userinfo().userGroup;
    },
    dishModelCount () {
      return this.modelList.length || 0;
    },
    currentDishModel () {
      return this.modelList[this.currentIndex];
    }
    // modelList () {
    //   let keys = Object.keys(this.detectedData);
    //   // return this.$_.intersectionWith(this.modelList2, keys, (leftVal, rightVal) => {
    //   //   return leftVal.class_id === rightVal;
    //   // });
    //   // return keys;
    //   return keys.map(a => {
    //     let target = this.$_.find(this.modelList2, (b) => {
    //       return a === b.class_id;
    //     });
    //     console.log(target);
    //     if (target) {
    //       // target.dish_name = !target.dish_name && target.dish_native_name ? target.dish_native_name + '(碗碟库)' : '暂无名称';
    //       if (target.dish_name && target.dish_native_name) {
    //         target.dish_name = target.dish_native_name;
    //       }
    //       return target;
    //     } else {
    //       return a;
    //     }
    //   });
    // }
  },
  watch: {
    listQuery () {
      this.getDetectedImages();
    },
    currentIndex () {
      this.emitLoading(300);
    }
  }
};
</script>
<style lang="scss" scoped>
  .container {
    .title {
      .main-title{
        display: inline-block;
      }
      .sub-title {
        display: inline-block;
        float: right;
      }
    }
    .tip-wrapper {
      display: inline-block;
      width: auto;
      padding: 20px;
      border: 2px solid red;
      border-radius: 20px;
    }
    .unMarked-card {
      height: 100%;
    }
    .header-title {
      display: inline-block;
    }
    .box-card {
      .btn-wrapper-1 {
        display: inline-block;
        margin-top: -10px;
        float: right;
      }
    }
    .btn-wrapper {
      padding-top: 50px;
      width: 80%;
      .btn-wrapper-1 {
        display: inline-block;
        margin-top: -10px;
        float: right;
      }
    }
    .image-wrapper {
      width: 150px;
      height: 150px;

      .image-item {
        width: auto;
        height: auto;
        max-width: 100%;
        max-height: 100%;
      }
    }
    .image-wrapper-1 {
      width: 100%;
      height: 100%;
      .image-item {
        width: auto;
        height: auto;
        max-width: 100%;
        max-height: 100%;
      }
      .image-item-wrapper {
        display: inline-block;
        width: 25px;
        height: 25px;
        .image-item {
          width: auto;
          height: auto;
          max-width: 100%;
          max-height: 100%;
        }
        .big-img {
          .big-img-wrapper {

            position: relative;
            .btn {
              position: absolute;
              left: 0;
              top: 0;
            }
          }
        }

      }
    }
    .current-dish-model {
      width: 150px;
      height: 150px;
    }
    .process-title {
      .strong-text {
        color: #ff0000
      }
    }
  }

</style>
